import { Component, Inject } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet'
import { ISelectItem } from '@mg-platform/core/core-ui'

@UntilDestroy()
@Component({
  selector: 'mg-dropdown-bottom-sheet',
  templateUrl: './dropdown-bottom-sheet.component.html',
  styleUrls: ['./dropdown-bottom-sheet.component.scss'],
  standalone: false
})
export class DropdownBottomSheetComponent {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<DropdownBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { items: ISelectItem[]; selectedItem: any; extraItemClass: string; title: string }
  ) {}

  selectItem(value: any) {
    this.bottomSheetRef.dismiss(value)
  }
}
